class ImageSlider {
  visibleContainers = [];

  constructor() {
    let allContainers = Array.from(document.querySelectorAll('.pdtImg'));
    if (!allContainers.length) return;

    this.visibleContainers = allContainers.filter(el => {
      const style = window.getComputedStyle(el);
      return style.display !== 'none';
    });

    this.activeIndices = new Map();
    this.init();
  }

  init() {
    this.visibleContainers.forEach(container => {
      const slides = Array.from(container.querySelectorAll('.pdtSlide .img > div'));
      const thumbs = Array.from(container.querySelectorAll('#pdtImgThbs img'));
      const dots = Array.from(container.querySelectorAll('#wDots li'));

      if (!slides.length) return;

      this.activeIndices.set(container, 0);

      const nextBtn = container.querySelector('#pdtNext');
      const prevBtn = container.querySelector('#pdtPrev');

      if (nextBtn) nextBtn.addEventListener('click', () => this.nextSlide(container, slides, thumbs, dots));
      if (prevBtn) prevBtn.addEventListener('click', () => this.prevSlide(container, slides, thumbs, dots));

      thumbs.forEach((thumb, idx) => {
        thumb.addEventListener('click', () => this.goToSlide(container, slides, thumbs, dots, idx));
      });

      dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => this.goToSlide(container, slides, thumbs, dots, idx));
      });

      let startX = null, startY = null;
      const slideEl = container.querySelector('.pdtSlide');
      if (slideEl) {
        slideEl.addEventListener('touchstart', e => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        }, { passive: true });

        slideEl.addEventListener('touchmove', e => {
          if (startX === null || startY === null) return;

          const diffX = startX - e.touches[0].clientX;
          const diffY = startY - e.touches[0].clientY;

          if (Math.abs(diffX) > Math.abs(diffY)) {
            if (diffX > 0) this.nextSlide(container, slides, thumbs, dots);
            else this.prevSlide(container, slides, thumbs, dots);
          }

          startX = null;
          startY = null;
        }, { passive: true });
      }

      this.updateSlide(container, slides, thumbs, dots, 0);
    });
  }

  updateSlide(container, slides, thumbs, dots, index) {
    slides.forEach(s => s.classList.remove('active'));
    thumbs.forEach(t => t.classList.remove('active'));
    dots.forEach(d => d.classList.remove('active'));

    if (slides[index]) slides[index].classList.add('active');
    if (thumbs[index]) thumbs[index].classList.add('active');
    if (dots[index]) dots[index].classList.add('active');

    this.activeIndices.set(container, index);
  }

  nextSlide(container, slides, thumbs, dots) {
    let current = this.activeIndices.get(container) || 0;
    let next = (current + 1) % slides.length;
    this.updateSlide(container, slides, thumbs, dots, next);
  }

  prevSlide(container, slides, thumbs, dots) {
    let current = this.activeIndices.get(container) || 0;
    let prev = (current - 1 + slides.length) % slides.length;
    this.updateSlide(container, slides, thumbs, dots, prev);
  }

  goToSlide(container, slides, thumbs, dots, index) {
    this.updateSlide(container, slides, thumbs, dots, index);
  }
}

export default ImageSlider;